import { toast } from "react-toastify";

export const useToast = () => {
  const showToast = (message, type = "info", options = {}) => {
    const config = {
      position: "top-center",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options,
    };

    if (type === "success") return toast.success(message, config);
    if (type === "error") return toast.error(message, config);
    if (type === "warn") return toast.warn(message, config);
    return toast.info(message, config);
  };

  return { showToast };
};
